import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { assert, isUndefined, generateFormat, pureObjectAssign, stringFormat, isString, isFunction, isArray } from '@dateam/ark';
import RouteData from './routeData';
var PATH_FORMAT_REGEXP = /\/<(.*?)>/g;
var PATH_CLEAR_REGEXP = /<(.*?)>/g;
var DEFAULT_TRANSITION = {
  className: 'page',
  enterTimeout: 1000,
  exitTimeout: 1000
};
var RouterHelper = /*#__PURE__*/function () {
  function RouterHelper() {
    _classCallCheck(this, RouterHelper);
    this.routes = [];
    this.guards = [];
    this.generatedRoutesPath = {};
    this.layout = void 0;
    this.layoutData = void 0;
    this.transitionEnabled = false;
    this.transitionConfig = null;
    this.otherwisePath = '/';
  }
  return _createClass(RouterHelper, [{
    key: "addGuards",
    value: function addGuards(guards) {
      var _this$guards;
      assert(isArray(guards) && !guards.some(function (guard) {
        return !isFunction(guard);
      }), 'guards are not valid');
      (_this$guards = this.guards).push.apply(_this$guards, _toConsumableArray(guards));
      return this;
    }
  }, {
    key: "setGuards",
    value: function setGuards(guards) {
      if (!isArray(guards) || guards.some(function (guard) {
        return !isFunction(guard);
      })) return this;
      this.guards = _toConsumableArray(guards);
      return this;
    }
  }, {
    key: "getGuards",
    value: function getGuards() {
      return this.guards;
    }
  }, {
    key: "add",
    value: function add(route) {
      this.routes.push(route);
      return this;
    }
  }, {
    key: "use",
    value: function use(path, router) {
      router.applyPathPrefix(path);
      this.routes.push(router);
      return this;
    }
  }, {
    key: "otherwise",
    value: function otherwise(redirectTo) {
      this.otherwisePath = redirectTo;
      return this;
    }
  }, {
    key: "setLayout",
    value: function setLayout(layout, data) {
      this.layout = layout;
      this.layoutData = data;
      return this;
    }
  }, {
    key: "enableTransition",
    value: function enableTransition() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.transitionEnabled = true;
      this.transitionConfig = pureObjectAssign(DEFAULT_TRANSITION, config);
      return this;
    }
  }, {
    key: "applyPathPrefix",
    value: function applyPathPrefix(path) {
      this.routes.forEach(function (route) {
        if (route instanceof RouteData) route.path = path + route.path;else if (route instanceof RouterHelper) route.applyPathPrefix(path);
      });
      return this;
    }
  }, {
    key: "generateRoutes",
    value: function generateRoutes() {
      var routes = this.getRoutes();
      this.generatedRoutesPath = routes.reduce(function (paths, route) {
        // Generate Route paths to allow future fetching
        paths[route.key] = generateFormat(route.path, PATH_FORMAT_REGEXP);

        // Clear path format
        route.path = route.path.replace(PATH_CLEAR_REGEXP, function (_, group) {
          return group;
        });
        return paths;
      }, {});
      return routes;
    }
  }, {
    key: "getPath",
    value: function getPath(key) {
      var path = this.generatedRoutesPath[key];
      if (!isString(path)) return undefined;
      for (var _len = arguments.length, format = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        format[_key - 1] = arguments[_key];
      }
      return stringFormat.apply(void 0, [path].concat(_toConsumableArray(format.map(function (v) {
        return v && "/".concat(v);
      }))));
    }
  }, {
    key: "getOtherwisePath",
    value: function getOtherwisePath() {
      return this.otherwisePath;
    }
  }, {
    key: "getRoutes",
    value: function getRoutes() {
      var _this = this;
      var routes = this.routes.map(function (route) {
        // Map clones of registered routes
        if (route instanceof RouteData) {
          var routeClone = Object.assign(Object.create(RouteData.prototype), route);
          return routeClone;
        }
        if (route instanceof RouterHelper) {
          var routerClone = Object.assign(Object.create(RouterHelper.prototype), route);
          return routerClone;
        }
        throw new Error('Router: unhandled registered route type.');
      }).reduce(function (routes, route) {
        if (route instanceof RouteData) {
          route.layout = _this.layout;
          if (isUndefined(route.layoutData)) {
            route.layoutData = _this.layoutData;
          }
          route.guards = _toConsumableArray(route.guards);
          if (_this.guards.length > 0) {
            route.applyGuards(_this.guards);
          }
          routes.push(route);
        } else if (route instanceof RouterHelper) {
          route.applyGuards(_this.guards);
          if (isUndefined(route.layout)) {
            route.setLayout(_this.layout, _this.layoutData);
          }
          routes.push.apply(routes, _toConsumableArray(route.getRoutes()));
        }
        return routes;
      }, []);

      // routes.forEach(route => console.log(route.key, route));
      return routes;
    }
  }, {
    key: "applyGuards",
    value: function applyGuards(guards) {
      var _this$guards2;
      (_this$guards2 = this.guards).unshift.apply(_this$guards2, _toConsumableArray(guards));
      return this;
    }
  }]);
}();
export { RouterHelper as default };